import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'checkbox-switch',
    templateUrl: './checkbox-switch.component.html',
    styleUrls: ['./checkbox-switch.component.css'],
    standalone: false
})
export class CheckboxSwitchComponent implements OnInit {

  @Input() value?: any;
  @Input() disableToggle: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  onCheckboxChange(checked: boolean): void {
    this.value = checked;
    this.valueChange.emit(this.value);
  }

}
